// import { useMutation } from '@tanstack/react-query';
// import { useNavigate } from 'react-router-dom';
// import toast from 'react-hot-toast';
// import authService from 'services/auth.service';
// import { useAuth } from 'contexts/AuthContext';

// export const useLogin = () => {
//   const navigate = useNavigate();
//   const { setUser } = useAuth();

//   return useMutation({
//     mutationFn: (credentials) => authService.login(credentials),
//     onSuccess: (data) => {
//       setUser(data?.user);
//       toast.success(`Welcome back, ${data.user.name}!`);
//       navigate('/admins', { replace: true });
//     },
//     onError: (error) => {
//       const errorMessage =
//         error.response?.data?.message ||
//         error.message ||
//         'Login failed. Please check your credentials.';
//       toast.error(errorMessage);
//     },
//   });
// };


import { useMutation } from '@tanstack/react-query';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import authService from 'services/auth.service';
import { useAuth } from 'contexts/AuthContext';

export const useLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { setUser } = useAuth();

  return useMutation({
    mutationFn: (credentials) => authService.login(credentials),
    onSuccess: (data) => {
      setUser(data?.user);
      toast.success(`Welcome back, ${data.user.name}!`);

      const isAdmin = data?.user?.role?.name === 'admin';
      const defaultPath = isAdmin ? '/executive-dashboard' : '/support-chat';

      // Only return to a previous page when the login was triggered by a
      // session expiry (ProtectedRoute's `from` state, or clearSessionAndRedirect's
      // `?from=` query param) — a fresh, direct visit to /login always goes to the dashboard.
      const returnTo = location.state?.from
        ? location.state.from.pathname + (location.state.from.search || '')
        : searchParams.get('from');

      navigate(returnTo || defaultPath, { replace: true });
    },
    onError: (error) => {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Login failed. Please check your credentials.';
      toast.error(errorMessage);
    },
  });
};